<template>
  <div
    style="padding: 12px;"
    class="member-view"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <div
      class="row"
      v-if="employerIdentity !== null && employerIdentity !== undefined"
    >
      <div class="col-12 col-md-9" style="padding-top:0">
        <material-card
          icon="work"
          :color="$vuetify.theme.themes.light.secondary"
          :title="translate2(employerIdentity.Current, 'Name')"
        >
          <v-card-text>
            <div class="row no-gutters">
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("globals.effective_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(employerIdentity.Current.EffectiveDate) }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("globals.number") }}
                <br />
                <span class="minfo">
                  {{ employerIdentity.Current.Number }}
                </span>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                {{ $t("globals.address") }}
                <br />
                <span class="minfo">
                  {{ displayAddress(employerIdentity.Current.Address) }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("globals.status") }}
                <br />
                <span class="minfo">
                  {{ translate(employerIdentity.Current.Status) }}
                </span>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                {{ $t("globals.telephone") }}
                <br />
                <span class="minfo">
                  {{ formatPhone(employerIdentity.Current.PhoneNumber) }}
                </span>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                {{ $t("headers.employers.phone2") }}
                <br />
                <span class="minfo">
                  {{ formatPhone(employerIdentity.Current.PhoneNumber2) }}
                </span>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                {{ $t("globals.fax_number") }}
                <br />
                <span class="minfo">
                  {{ formatPhone(employerIdentity.Current.Fax) }}
                </span>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                {{ $t("headers.contacts.email") }}
                <br />
                <span class="minfo">
                  <a :href="'mailto:' + employerIdentity.Current.Email">
                    {{ employerIdentity.Current.Email }}
                  </a>
                </span>
              </div>
            </div>
            <v-expansion-panels style="margin-top:10px">
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{
                          $t(
                            "components.employers.employer_details.employers_history"
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <employer-history-table
                    ref="employerHistoryTable"
                    :employerId="id"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        mail
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("globals.contacts") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <pbas-simple-table
                    ref="employerDetailsContactsSimple"
                    :dataProvider="contactsProvider"
                    fileNamePrefix="employerDetailsContactsSimple"
                    :identifier="
                      'employerDetailsContactsSimple' + selectedPlan.Id
                    "
                    @error="error = $event"
                  ></pbas-simple-table> -->
                  <contacts
                    ref="contacts"
                    entity="Employer"
                    :filter="'EmployerId eq ' + id"
                    :relatedHeaders="contactsHeaders"
                    identifier="employerContacts"
                    :employerId="id"
                    @close="$emit('close')"
                  ></contacts>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>

        <employer-stores-table
          ref="employerStoresTable"
          v-if="planOptions.HasStores"
          :employerId="id"
        />

        <!-- <material-card
          icon="card_membership"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.employers.employer_details.contributions')"
        >
          <!-- summary row -->
        <!-- contributions table -->
        <!-- history table --
        </material-card> -->

        <employer-contributions
          :employerId="id"
          :hasLocations="planIdentity.Current && planIdentity.Current.ReportsPerStore && employerIdentity.Stores.length > 0"
        />

        <employer-files-table
          v-if="useDocumentsManagement"
          ref="employerFilesTable"
          :id="id"
        />
      </div>
      <div class="col-12 col-md-3" style="padding-top:0">
        <v-card>
          <v-card-text>
            <v-container fill-height fluid>
              <v-row align="center" justify="center" no-gutters>
                <v-col
                  cols="12"
                  v-if="employerIdentity.Current.LogoBase64"
                  style="text-align:center"
                >
                  <img
                    :id="imgControlId"
                    :src="employerIdentity.Current.LogoBase64"
                    style="height:100px;cursor:pointer"
                  />
                </v-col>
                <v-col
                  cols="12"
                  v-if="employerIdentity.Current.LogoBase64"
                  style="text-align:center"
                >
                  <v-btn @click="dialogs.logo = true" color="primary" text>
                    <v-icon>photo_camera</v-icon>
                    {{ $t("components.employers.employer_details.edit_logo") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" v-else style="text-align:center">
                  <v-btn @click="dialogs.logo = true" color="primary" text>
                    <v-icon>photo_camera</v-icon>
                    {{ $t("components.employers.employer_details.add_logo") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
        <!-- </material-card> -->
        <v-card style="margin-top:10px">
          <v-list :expand="true">
            <v-subheader>
              <v-icon style="margin-right: 6px">handyman</v-icon>
              {{ $t("globals.edit") }}
            </v-subheader>

            <v-list-group no-action prepend-icon="info" :value="true">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t(
                        "components.employers.employer_details.employer_information"
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="dialogs.correctInfo = true"
                v-if="!selectedPlan.Current.IsTesting"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t(
                        "components.employers.employer_details.correct_information"
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="dialogs.generalInfo = true"
                v-if="!selectedPlan.Current.IsTesting"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t(
                        "components.employers.employer_details.view_edit_general_information"
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item @click="dialogs.contacts = true">
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.view_edit_contacts"
                    )
                  }}
                </v-list-item-title>
              </v-list-item> -->
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="store"
              :value="true"
              v-if="planOptions.HasStores"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("globals.stores") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <!-- <v-list-item @click="dialogs.correctBranchInfo = true">
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.correct_information"
                    )
                  }}
                </v-list-item-title>
              </v-list-item> -->
              <v-list-item
                @click="dialogs.addBranch = true"
                v-if="!selectedPlan.Current.IsTesting"
              >
                <v-list-item-title>
                  {{ $t("components.employers.employer_details.add_branch") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.branches = true">
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.view_edit_branches"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action prepend-icon="date_range" :value="true">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t(
                        "components.employers.employer_details.terms_and_rates"
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item @click="dialogs.wip = true">
                <!-- <v-list-item @click="dialogs.terms = true"> -->
                <v-list-item-title>
                  {{
                    $t("components.employers.employer_details.view_edit_terms")
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.wip = true">
                <!-- <v-list-item @click="dialogs.rates = true"> -->
                <v-list-item-title>
                  {{
                    $t("components.employers.employer_details.view_edit_rates")
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action prepend-icon="attach_money" :value="true">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.employers.employer_details.payments") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item @click="dialogs.wip = true">
                <!-- <v-list-item @click="dialogs.addPayment = true"> -->
                <v-list-item-title>
                  {{ $t("components.employers.employer_details.add_payment") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="dialogs.depositAccount = true"
                v-if="planIdentity.TrustFund && planIdentity.TrustFund.BankAccount"
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.view_deposit_account"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.wip = true">
                <!-- <v-list-item @click="dialogs.remittanceStatus = true"> -->
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.assign_remittance_status"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.viewBalanceStatement = true">
                <v-list-item-title>
                  {{ $t("components.employers.employer_details.view_balance_statement") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action prepend-icon="sticky_note_2" :value="true">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.employers.employer_details.notes") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="
                  note = {
                    Title: '',
                    Text: '',
                    Category: null,
                    EmployerId: id,
                    IsActive: true,
                  };
                  dialogs.addNote = true;
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.add_note") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.activeNotes = true">
                <v-list-item-title>
                  {{ $t("components.memberview.viewedit_active_notes") }}
                </v-list-item-title>
                <v-list-item-icon>
                  <v-badge
                    bordered
                    color="error"
                    :content="activeNotesCount.toString()"
                    offset-y="18"
                  ></v-badge>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="dialogs.archivedNotes = true">
                <v-list-item-title>
                  {{ $t("components.memberview.view_notes_archive") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="folder_shared"
              :value="true"
              v-if="useDocumentsManagement"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.documents") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="
                  fileCategory = 'CollectiveAgreement';
                  dialogs.addFile = true;
                "
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.add_collective_agreement"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  fileCategory = 'Other';
                  dialogs.addFile = true;
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.add_other_file") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  fileCategory = 'Correspondence';
                  dialogs.addFile = true;
                "
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.add_correspondence"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  fileCategory = 'NoticeOfDelinquency';
                  dialogs.addFile = true;
                "
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.employers.employer_details.notice_of_delinquency"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dialogs.files = true">
                <v-list-item-title>
                  {{ $t("components.memberview.viewedit_file") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </div>
    </div>
    <error-handler :error="error"></error-handler>
    <!-- <employer-contacts-dialog
      :model="dialogs.contacts"
      :employerId="id"
      @close="
        dialogs.contacts = false;
        $refs.employerDetailsContactsSimple &&
          $refs.employerDetailsContactsSimple.getDataAsync();
      "
    /> -->
    <employer-stores-dialog
      :model="dialogs.branches"
      :employerId="id"
      @close="
        dialogs.branches = false;
        $refs.employerStoresTable && $refs.employerStoresTable.reload();
      "
    />
    <correct-employer-information-dialog
      :model="dialogs.correctInfo"
      :id="id"
      @close="
        dialogs.correctInfo = false;
        reload();
      "
    />
    <employer-logo-dialog
      :model="dialogs.logo"
      :id="id"
      @close="
        dialogs.logo = false;
        reload();
      "
    />
    <wip-dialog :model="dialogs.wip" :id="id" @close="dialogs.wip = false" />
    <employer-store-wizard-dialog
      :employerId="id"
      :model="dialogs.addBranch"
      :id="undefined"
      @close="
        dialogs.addBranch = false;
        $refs.employerStoresTable && $refs.employerStoresTable.reload();
      "
    />
    <employer-wizard-dialog
      :id="id"
      :model="dialogs.generalInfo"
      @close="
        dialogs.generalInfo = false;
        reload();
      "
    />
    <employer-notes-add-dialog
      v-if="employerIdentity"
      :id="id"
      :model="dialogs.addNote"
      @close="
        dialogs.addNote = false;
        reloadActiveNotesCount();
      "
      :note="note"
      :name="translate2(employerIdentity.Current, 'Name')"
    />
    <employer-active-notes-dialog
      v-if="employerIdentity"
      :id="id"
      :model="dialogs.activeNotes"
      @close="dialogs.activeNotes = false"
      :name="translate2(employerIdentity.Current, 'Name')"
      @load-data="reloadActiveNotesCount()"
    />
    <employer-archived-notes-dialog
      v-if="employerIdentity"
      :id="id"
      :model="dialogs.archivedNotes"
      @close="dialogs.archivedNotes = false"
      :name="translate2(employerIdentity.Current, 'Name')"
      @load-data="reloadActiveNotesCount()"
    />
    <employer-files-dialog
      v-if="employerIdentity"
      :employerIdentityId="id"
      :model="dialogs.files"
      :title="
        $t('components.employers.employer_details.employer_{0}_files', [
          translate2(employerIdentity.Current, 'Name'),
        ])
      "
      @close="dialogs.files = false"
    />
    <employer-add-file-dialog
      v-if="employerIdentity"
      :id="id"
      :model="dialogs.addFile"
      @close="
        dialogs.addFile = false;
        reloadFiles();
      "
      :category="fileCategory"
      :name="translate2(employerIdentity.Current, 'Name')"
    />
    <view-bank-account-dialog
      :model="dialogs.depositAccount"
      @close="dialogs.depositAccount = false"
    />
    <employer-balance-statement-dialog
      v-if="employerIdentity"
      :employerIdentityId="id"
      :model="dialogs.viewBalanceStatement"
      @close="dialogs.viewBalanceStatement = false"
      :name="translate2(employerIdentity.Current, 'Name')"
    />
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { locker } from "@/mixins/locker";
import { planSetter } from "@/mixins/planSetter";
import ErrorHandler from "@/components/ErrorHandler";
import { translate2 } from "@/trans2";
import { translate } from "@/trans";
import EmployerContactsHeaders from "@/headers/EmployerContacts";
import { ODataProvider } from "pbas-vue-components";
import ContactsHeaders from "@/headers/Contacts";
// import EmployerContactsDialog from "@/components/Employers/EmployerContactsDialog.vue";
import EmployerStoresTable from "@/components/Employers/EmployerStoresTable.vue";
import EmployerHistoryTable from "@/components/Employers/EmployerHistoryTable.vue";
import EmployerStoresDialog from "@/components/Employers/EmployerStoresDialog.vue";
import CorrectEmployerInformationDialog from "@/components/Employers/CorrectEmployerInformationDialog.vue";
import EmployerLogoDialog from "@/components/Employers/EmployerLogoDialog.vue";
import WipDialog from "@/components/Dialogs/WipDialog.vue";
import EmployerStoreWizardDialog from "@/components/Employers/EmployerStoreWizardDialog.vue";
import EmployerWizardDialog from "@/components/Employers/EmployerWizardDialog.vue";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { ODataHeader, ODataString } from "pbas-vue-components";
import Contacts from "@/components/Employers/Contacts.vue";
import EmployerNotesAddDialog from "@/components/Employers/EmployerNotesAddDialog.vue";
import EmployerActiveNotesDialog from "@/components/Employers/EmployerActiveNotesDialog.vue";
import EmployerArchivedNotesDialog from "@/components/Employers/EmployerArchivedNotesDialog.vue";
import EmployerFilesTable from "@/components/Employers/EmployerFilesTable.vue";
import EmployerFilesDialog from "@/components/Employers/EmployerFilesDialog.vue";
import EmployerAddFileDialog from "@/components/Employers/EmployerAddFileDialog.vue";
import ViewBankAccountDialog from "@/components/Employers/ViewBankAccountDialog.vue";
import SettingsService from "@/services/settings.service.js";
import EmployerContributions from "@/components/Employers/EmployerContributions.vue";
import EmployerBalanceStatementDialog from "@/components/Employers/EmployerBalanceStatementDialog.vue";
export default {
  props: {
    id: String,
  },
  components: {
    ErrorHandler,
    // EmployerContactsDialog,
    EmployerStoresTable,
    EmployerStoresDialog,
    CorrectEmployerInformationDialog,
    EmployerLogoDialog,
    WipDialog,
    EmployerStoreWizardDialog,
    EmployerWizardDialog,
    Contacts,
    EmployerHistoryTable,
    EmployerNotesAddDialog,
    EmployerActiveNotesDialog,
    EmployerArchivedNotesDialog,
    EmployerFilesTable,
    EmployerFilesDialog,
    EmployerAddFileDialog,
    ViewBankAccountDialog,
    EmployerContributions,
    EmployerBalanceStatementDialog
  },
  mixins: [locker, planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("plansMembers", ["options", "planIdentity", "planOptions"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
  },
  data() {
    return {
      error: null,
      employerIdentity: null,
      dialogs: {
        correctInfo: false,
        generalInfo: false,
        // contacts: false,
        // correctBranchInfo: false,
        addBranch: false,
        branches: false,
        terms: false,
        rates: false,
        addPayment: false,
        depositAccount: false,
        remittanceStatus: false,
        addNote: false,
        activeNotes: false,
        archivedNotes: false,
        // addCollectiveAgreement: false,
        addFile: false,
        // addCorrespondence: false,
        // noticeOfDelinquency: false,
        files: false,
        logo: false,
        wip: false,
        viewBalanceStatement: false
      },
      fileCategory: "other",
      activeNotesCount: 0,
      contactsProvider: undefined,
      imgControlId:
        "img-" +
        Math.random()
          .toString()
          .substr(2, 8),
      telephoneMask: "(###) ### - ####",
      contactsHeaders: [
        new ODataHeader({
          type: new ODataString("Employer/Current/Name"),
          sortable: true,
          visible: false,
          searchable: true,
          version: 2,
          allowVisibilityChange: false,
        }),
        new ODataHeader({
          title: "globals.employer",
          type: new ODataString("Employer/Current/Translations[]/Name", {
            getString: (item) => translate2(item.Employer, "Name"),
          }),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "Name",
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/LanguageCode"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/Id"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/RefId"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Employer Id",
          type: new ODataString("Employer/Current/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "EmployerId",
          type: new ODataString("EmployerId"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      note: null,
      hasContributionTerm: false,//TODO:
    };
  },
  mounted() {
    if (this.selectedPlan) {
      this.loadData();
    }
  },
  watch: {
    selectedPlan: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "getEmployerById",
      "getContributionsEmployerById",
      "getEmployerActiveNotesCount",
    ]),
    async reloadActiveNotesCount() {
      this.activeNotesCount = (await this.getEmployerActiveNotesCount({
        planIdentityId: this.selectedPlan.Id,
        employerIdentityId: this.id,
      })).data["Notes@odata.count"];
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async loadData() {
      try {
        this.employerIdentity = (await this.getEmployerById({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.id,
        })).data;
        this.hasContributionTerm = (await this.getContributionsEmployerById({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.id,
        })).data.EmployerContributionTerm !== null;
        // console.log(this.employerIdentity);
        this.reloadActiveNotesCount();
        const contactsHeaders = ContactsHeaders.concat(EmployerContactsHeaders);
        const url = `plans/${this.selectedPlan.Id}/contacts`;
        this.contactsProvider = new ODataProvider(
          this.$axiosHttp,
          url,
          contactsHeaders
        );
        this.contactsProvider.filter = `EmployerId eq ${this.id}`;
      } catch (error) {
        this.error = error;
      }
    },
    async reload() {
      try {
        this.employerIdentity = (await this.getEmployerById({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.id,
        })).data;
        this.hasContributionTerm = (await this.getContributionsEmployerById({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.id,
        })).data.EmployerContributionTerm !== null;
        if (this.$refs.employerHistoryTable) {
          this.$refs.employerHistoryTable.getDataAsync();
        }
      } catch (error) {
        this.error = error;
      }
    },
    reloadFiles() {
      this.$refs.employerFilesTable && this.$refs.employerFilesTable.loadData();
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    translate(item) {
      return translate(item, this.language.language);
    },
    displayAddress(address) {
      let res = "";
      if (address) {
        if (address.SuiteNumber) {
          res += address.SuiteNumber;
        }
        if (address.StreetNumber) {
          if (res.length > 0) {
            res += ", ";
          }
          res += address.StreetNumber.toString();
        }
        if (address.StreetName) {
          if (res.length > 0) {
            res += ", ";
          }
          res += address.StreetName;
        }
        if (res.length > 0) {
          res += ", ";
        }

        res += address.City + ", " + address.Province.Code;
        if (address.PostalCode) {
          res += " " + address.PostalCode;
        }
      }
      return res;
    },
    formatPhone(v) {
      return masker(v, this.telephoneMask, true, tokens);
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.member-view /deep/ .v-list-group__items > .v-list-item {
  padding-left: 45px;
}
.text-white {
  color: white;
}
</style>
